/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

import { i18nStrings as it } from './locales/it';
import { i18nStrings as de } from './locales/de';
import { i18nStrings as en } from './locales/en';

const i18nStrings = {
	it: it, // default language
	de: de,
	//en: en
}

export const LanguageTypes = [
	{
		"code": "it",
		"lang": "Italiano"
	},
	{
		"code": "de",
		"lang": "Deutsch"
	},
	/*
	{
		"code": "en",
		"lang": "English"
	},
	*/
];

export default i18nStrings;
